<div class="body_container"  *ngIf="isLoggedIn && !isJobOperator"
    [ngClass]="currentEntity == 'Configurator' ? 'configuratorView' : ''">

    <!-- First Row: Create Deployment -->
    <div class="row" style="flex: 0 !important;" *ngIf="currentEntity != 'Configurator'">
      <div class="listHeader" *ngIf="currentEntity != 'Configurator'">
        <h4 style="font-size: 14px;">Deploy : </h4>
      </div>

      <div class="row">
        <div class="col-auto" style="cursor: pointer;">
          <a (click)="redirectToCloudProviders('hpc')" class="card border-0 text-decoration-none tile">
            <div class="tile-content">
              <div class="image-section">
                <img src="../../../../../assets/images/syncious/hpc.png" alt="HPC Deployment">
              </div>
              <div class="text-section">
                <h6 class="heading">HPC</h6>
                <p class="description">Create a HPC deployment</p>
              </div>
            </div>
          </a>
        </div>
  
        <div class="col-auto" style="cursor: pointer;">
          <a (click)="redirectToCloudProviders('vdi')" class="card border-0 text-decoration-none tile">
            <div class="tile-content">
              <div class="image-section">
                <img src="../../../../../assets/images/syncious/vdi.png" alt="AI Deployment">
              </div>
              <div class="text-section">
                <h6 class="heading">VDI</h6>
                <p class="description">Attach your existing VDI infrastructure</p>
              </div>
            </div>
          </a>
        </div>
      
        <div class="col-auto" style="cursor: pointer;">
          <a (click)="redirectToCloudProviders('aiml')" class="card border-0 text-decoration-none tile">
            <div class="tile-content">
              <div class="image-section">
                <img src="../../../../../assets/images/syncious/ai.png" alt="VDI Deployment">
              </div>
              <div class="text-section">
                <h6 class="heading">AI Lab</h6>
                <p class="description">Platform to manage AI infra</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

     <!-- Third Row: Navigation Toggles -->
     <div class="row" style="flex: 0 !important; margin-top: 35px;">
      <div class="col-12">
        <div class="navigate-section">
          <h4 style="font-size: 14px;" class="mb-4 listHeader">Quick Access : </h4>
          
          <div class="d-flex gap-3">

            <div class="navigation-item d-flex align-items-center" [routerLink]="['/Node List']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-diagram-3" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Nodes</span>
            </div>

            <div class="navigation-item d-flex align-items-center" [routerLink]="['/Job List']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-briefcase" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Jobs</span>
            </div>

            <div class="navigation-item d-flex align-items-center" [routerLink]="['/Session List']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-pc-display-horizontal" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Sessions</span>
            </div>

            <div class="navigation-item d-flex align-items-center" [routerLink]="['/Storage List']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-hdd" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Storages</span>
            </div>

            <div class="navigation-item d-flex align-items-center" [routerLink]="['/User List']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-people" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Users</span>
            </div>
            
            <div class="navigation-item d-flex align-items-center" [routerLink]="['/Applications List']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-disc" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Applications</span>
            </div>

            <div class="navigation-item d-flex align-items-center" [routerLink]="['/Licenses List']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-journal-bookmark" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Licenses</span>
            </div>

            <div class="navigation-item d-flex align-items-center" [routerLink]="['/Configurator/Overview']" routerLinkActive="active">
              <div class="icon-container">
                <i class="bi bi-gear" style="color: var(--s-primary-color)"></i>
              </div>
              <span class="nav-text">Settings</span>
            </div>
  
          </div>
        </div>
      </div>
    </div>

    <!-- Deployment List Table -->
    <div class="row" style="flex: 0 !important; margin-top: 35px;">
      <div class="listHeader" *ngIf="currentEntity != 'Configurator'">
        <h4 style="font-size: 14px;">Deployment List : </h4>
      </div>
      <div class="table-container">
        <table class="table table-hover" style="white-space: nowrap;"
            [ngClass]="currentEntity != 'Configurator' ? 'main-panel-table' : ''">
        <thead>
          <tr class="table-list-head">
            <th resizable scope="col">#</th>
            <th resizable scope="col">
              Name
              <span style="cursor: pointer" [ngClass]="
                      sortName == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                    class="bi" (click)="sortByName()"></span>
            </th>
            <th resizable scope="col">
              Location
              <span style="cursor: pointer" [ngClass]="
                      sortLocation == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                    class="bi" (click)="sortByLocation()"></span>
            </th>
            <th resizable scope="col">
              Scheduler
              <span style="cursor: pointer" [ngClass]="
                      sortScheduler == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                    class="bi" (click)="sortByScheduler()"></span>
            </th>
            <th resizable scope="col">
              Infrastructure
              <span style="cursor: pointer" [ngClass]="
                      sortInfrastructure == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                    class="bi" (click)="sortByInfrastructure()"></span>
            </th>
            <th resizable scope="col">
              Status
              <span style="cursor: pointer" [ngClass]="
                      sortStatus == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'"
                      class="bi" (click)="sortByStatus()"></span>
            </th>
            <th *ngIf="isPathConfigurator" resizable scope="col"></th>
          </tr>
        </thead>
        <tbody *ngIf="!dataEmpty">
          <tr class="table-list-row"
              *ngFor="let dep of deployments; let i = index"
              style="cursor: pointer; outline: none; vertical-align: middle;">
            <td scope="row"> {{ i + 1 }} </td>
            <td (click)="redirectTo(dep)" class="impListName">
              {{ dep.name }}
            </td>
            <td (click)="redirectTo(dep)">{{ dep.location || 'NA' }}</td>
            <td (click)="redirectTo(dep)">{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  'NA' : dep.scheduler}}</td>
            <td (click)="redirectTo(dep)">{{ dep.numOfComputeNodes == -1 && dep.headNodeIp == "NA" ?  dep.cloud + ": VDI" : dep.cloud}}</td>
    
            <td (click)="redirectTo(dep)">
              <label for="" title="{{dep.status}}">{{ dep.status || 'NA' | splitWord }}</label>
            </td>
            <td *ngIf="isPathConfigurator" style="text-align: center;">
              <div>
                <button type="button"
                        [class.hideStatus]="checkIfOnPremiseDeployment(dep.cloud)"
                        class="default-btn me-3"
                        (click)="checkDepStatus(dep.name, dep.id)">
                  Check Status
                </button>
                <button class="default-btn"
                        *ngIf="isUserGlobalAdmin"
                        (click)="deleteDeployment(dep.name)"
                        title="Delete Deployment.">
                  Delete
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%">
        No Deployment Available.
      </p>
    </div>
    
  <ngx-spinner bdColor="rgba(0,0,0,0)"
      size="default" zIndex="1"
      color="var(--s-primary-color)"
      type="ball-spin"
      [fullScreen]="false"><p>Please wait ...</p></ngx-spinner>
</div>
